// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const GiftIconGradient = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18.376 10.608H1.75V8.274c0-.32.261-.582.582-.582h16.336c.321 0 .582.261.582.582l.002 2.335h-.876Zm-.584 11.097a.57.57 0 0 1-.57.57H3.778a.57.57 0 0 1-.57-.57v-9.93h14.584v9.93ZM5.294 3.186c.071-.56.516-1.095 1.107-1.332.215-.086.437-.128.661-.128.472 0 .955.187 1.408.555 1.136.92 1.395 2.83 1.445 3.94l-.006.206c-.469-.101-1.225-.305-2.326-.717-1.002-.376-2.437-1.357-2.29-2.524Zm7.236-.905c.453-.368.936-.555 1.408-.555.224 0 .446.042.661.128.591.238 1.036.773 1.107 1.332.148 1.167-1.287 2.148-2.288 2.524-1.102.412-1.858.616-2.326.717-.002-.078-.005-.161-.01-.248.065-1.223.388-3.04 1.448-3.898Zm6.139 4.243h-4.21c1.414-.713 2.596-1.975 2.404-3.485-.124-.981-.843-1.871-1.83-2.267-1.06-.426-2.24-.207-3.238.602-.602.488-1.014 1.151-1.295 1.854-.282-.703-.693-1.366-1.295-1.854C8.207.566 7.027.346 5.967.772c-.987.395-1.705 1.286-1.83 2.267-.193 1.51.99 2.772 2.404 3.485H2.33A1.75 1.75 0 0 0 .584 8.273v2.336c0 .643.523 1.165 1.166 1.165h.293v9.93c0 .958.778 1.737 1.736 1.737h13.444c.957 0 1.736-.779 1.736-1.736v-9.93h.293c.643 0 1.166-.524 1.166-1.166V8.273a1.75 1.75 0 0 0-1.748-1.749Z"
			fill="url(#GiftIconGradient_tsx__a)"
		/>
		<defs>
			<linearGradient
				id="GiftIconGradient_tsx__a"
				x1={0.583}
				y1={0.559}
				x2={23.234}
				y2={20.191}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#75F0F0" />
				<stop offset={1} stopColor="#7575F0" />
			</linearGradient>
		</defs>
	</svg>
);
export default GiftIconGradient;
